/**
 * DriverInstructionsFieldButton - Driver instructions field button using existing hooks
 */

import {useDriverInstructions} from '@hconnect/tuc-processes/fields/textField'
import React from 'react'
import {useTranslation} from 'react-i18next'

import {FieldButton} from '../../FieldButton'

interface DriverInstructionsFieldButtonProps {
  onClick: () => void
  requiresApproval?: boolean
  isReadOnly?: boolean
  isChanged?: boolean
}

export const DriverInstructionsFieldButton: React.FC<DriverInstructionsFieldButtonProps> = ({
  onClick,
  requiresApproval = false,
  isReadOnly = false,
  isChanged = false
}) => {
  const {t} = useTranslation()
  const {driverInstructions, error} = useDriverInstructions()

  // Following useRmcOrderEditLogic withFallback pattern - return null for empty
  const trimmed = driverInstructions?.toString().trim()
  const displayValue = trimmed && trimmed.length > 0 ? trimmed : null

  return (
    <FieldButton
      label={t('orderIntake.rmc.orderManagement.editSteps.labels.driverInstructions', 'Driver instructions')}
      value={displayValue}
      onClick={onClick}
      requiresApproval={requiresApproval}
      isReadOnly={isReadOnly}
      isChanged={isChanged}
    />
  )
}
